<template>
  <div class="asc-derived-parameter-grid--wrapper">
    <asc-derived-parameter-grid
      class="asc-derived-parameter-grid"
      :values="values"
      :column-defs="columnDefs"
      :deselect-all-rows="deselectAllRows"
      :disabled="gridDisabled"
      :loading="loading"
      @onSelectionChanged="handleSelectionChanged"
      @deselectedAllRows="deselectedAllRowsHandler"
      @openAlertTypeDialog="openAlertTypeDialogHandler"
    />
    <asc-sticky
      v-if="selectedRowCount > 0 && !hideActionFooter"
      :is-sticky="true"
      :full-width="true"
      :sticky-footer="true"
    >
      <div class="asc-derived-parameter-grid--actionFooter">
        <asc-accent-button
          :on-click="handleCancelMassDelete"
          secondary
          button-text="Cancel"
        ></asc-accent-button>
        <asc-accent-button
          :on-click="handleDeleteDerivedParameters"
          button-text="Delete Selected"
        ></asc-accent-button>
        <span>({{ selectedRowCount }} of {{ values.length }})</span>
      </div>
    </asc-sticky>
  </div>
</template>

<script>
import AscDerivedParameterGrid from '../molecules/AscDerivedParameterGrid.vue' //'@/components/molecules/AscDerivedParameterGrid'
import AscAccentButton from '../atoms/AscAccentButton.vue' //'@/components/atoms/AscAccentButton'
import AscSticky from '../atoms/AscSticky.vue' //'@/components/atoms/AscSticky'
import { AscGridPropsMixin, AscGridMethodsMixin } from '../mixins' //'@/components/mixins'
import { stringTextMatcher } from '../agGrid/AgGridHelperMethods' //'@/components/agGrid/AgGridHelperMethods'
import { AscAgGridDateFloatFilter, AscLinkCellRenderer } from '../agGrid' //'@/components/agGrid'

export default {
  name: 'AscDerivedParameterGridWrapper',

  components: {
    AscDerivedParameterGrid,
    AscLinkCellRenderer,
    AscAgGridDateFloatFilter,
    AscAccentButton,
    AscSticky,
  },

  mixins: [AscGridPropsMixin, AscGridMethodsMixin],

  props: {
    values: {
      type: Array,
      default: () => [],
    },
    gridDisabled: {
      type: Boolean,
      default: false,
    },
    hideActionFooter: {
      type: Boolean,
      default: false,
    },
    userAirlines: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selectedRowCount: 0,
      selectedRows: [],
      deselectAllRows: false,
      columnDefs: this.getColumnDefs(),
    }
  },

  watch: {
    values() {
      this.selectedRowCount = 0
      this.deselectAllRows = true
      this.columnDefs = this.getColumnDefs()
    },
    selectedRowCount(newValue) {
      const QSISlider = document.querySelector('.QSISlider')
      if (newValue > 0) {
        if (QSISlider) QSISlider.style.display = 'none'
      } else {
        if (QSISlider) QSISlider.style.display = 'block'
      }
    },
  },

  methods: {
    openAlertTypeDialogHandler() {
      this.$emit('openAlertTypeDialog')
    },

    handleCancelMassDelete() {
      this.selectedRowCount = 0
      this.deselectAllRows = true
    },

    deselectedAllRowsHandler() {
      this.deselectAllRows = false
    },

    handleSelectionChanged(rows) {
      this.selectedRowCount = rows.length
      this.selectedRows = rows
    },

    handleDeleteDerivedParameters() {
      if (this.selectedRows.length) {
        this.$emit('onDeleteDerivedParameters', this.selectedRows)
      }
    },

    handleCellClick(arg) {
      this.$emit('copyParameter', arg)
    },

    getColumnDefs() {
      const columnDefs = [
        {
          headerName: '',
          field: '',
          width: 42,
          maxWidth: 42,
          resizable: false,
          checkboxSelection: true,
          headerCheckboxSelection: true,
          suppressMovable: true,
          suppressSizeToFit: true,
        },
        {
          headerName: this.getColumnTitle(this.gridColumns, 'name', 'Name'),
          field: 'name',
          filter: 'agTextColumnFilter',
          suppressMovable: true,
          suppressSizeToFit: false,
          cellRenderer: 'AscLinkCellRenderer',
          sort: 'asc',
          cellRendererParams: {
            disabled: this.disableFullFlightToggles,
            callback: arg => this.handleCellClick(arg),
            iconClass: 'mdi-plus-circle-multiple-outline',
          },
        },
        {
          headerName: this.getColumnTitle(
            this.gridColumns,
            'alertType',
            'Type',
          ),
          field: 'alertType',
          filter: 'agTextColumnFilter',
          suppressMovable: true,
          suppressSizeToFit: false,
          sortable: true,
          filterParams: {
            textMatcher: stringTextMatcher,
          },
          floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
          floatingFilterComponentParams: {
            ids: [],
            items: this.getUniqueItems('alertType'),
            suppressFilterButton: true,
          },
        },
        {
          headerName: this.getColumnTitle(this.gridColumns, 'string', 'String'),
          field: 'logicString',
          filter: 'agTextColumnFilter',
          suppressMovable: true,
          suppressSizeToFit: false,
          sortable: true,
        },
      ]
      if (this.userAirlines.length > 1) {
        columnDefs.push({
          headerName: this.getColumnTitle(
            this.gridColumns,
            'airline',
            'Airline',
          ),
          field: 'airline',
          filter: 'agTextColumnFilter',
          suppressMovable: true,
          suppressSizeToFit: false,
          sortable: true,
          filterParams: {
            textMatcher: stringTextMatcher,
          },
          floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
          floatingFilterComponentParams: {
            ids: [],
            items: this.getUniqueItems('airline'),
            suppressFilterButton: true,
          },
        })
      }
      columnDefs.push({
        headerName: this.getColumnTitle(
          this.gridColumns,
          'masterModel',
          'Platform',
        ),
        field: 'masterModel',
        filter: 'agTextColumnFilter',
        suppressMovable: true,
        suppressSizeToFit: false,
        sortable: true,
        filterParams: {
          textMatcher: stringTextMatcher,
        },
        floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
        floatingFilterComponentParams: {
          ids: [],
          items: this.getUniqueItems('masterModel'),
          suppressFilterButton: true,
        },
      })
      return columnDefs
    },
  },
}
</script>

<style lang="scss">
.asc-derived-parameter-grid--actionFooter {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 16px;

  .asc-accent-button-container {
    margin-right: 12px;
  }
}
.asc-derived-parameter-grid {
  &--wrapper {
    .asc-grid-wrapper-header--container {
      margin: 0 16px 19px 16px;
    }

    .asc-derived-parameter-grid {
      .link-grid-cell {
        cursor: pointer;

        label {
          cursor: pointer;
          color: $accent-700;
        }

        i.v-icon {
          cursor: pointer;
          color: $accent-700;

          &.mdi-plus-circle-multiple-outline {
            display: none;
            padding-left: 5px !important;
          }

          &.mdi-chevron-right {
            margin-left: 5.3px;
          }
        }

        &:hover {
          &.document {
            background-color: $accent-0;

            label {
              text-decoration: underline;
            }
          }

          i.v-icon {
            &.mdi-plus-circle-multiple-outline {
              position: absolute;
              margin-left: 5px;
              display: inline;
            }
          }
        }
      }
    }
  }
}
</style>
